import AppProviders from "components/AppProviders";
import AppRoutes from "routes/AppRoutes";

const App = () => (
  <AppProviders>
    <AppRoutes />
  </AppProviders>
);

export default App;
